<script>
import appConfig from "@/app.config";
export default {
  computed:{
    getAppVersion(){
      return appConfig.version;
    }
  }
}
</script>
<template>
  <footer class="footer" style="left: 0px;">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">{{ new Date().getFullYear() }} © CCB IT.</div>
        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block"><span class="ms-4">Version: {{getAppVersion}}</span>&nbsp;-&nbsp;Powered By Diversitude</div>
          
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
